import Drawer from '@mui/material/Drawer'
import { getTipById } from 'api/tips'
import DrawerContainer from 'components/drawer/common/DrawerContainer'
import { defaultDrawerSX } from 'const'
import { useEntityDataControl } from 'hooks/useEntityDataControl'
import { TipDrawerViewContent } from './TipDrawerViewContent'

export const TipDrawerView = ({
  id,
  isOpen,
  handleClose,
}: {
  id: number
  isOpen: boolean
  handleClose: () => void
}) => {
  const { data, loading } = useEntityDataControl({
    id,
    loadFunc: getTipById,
    warning: "Can't load the tip",
  })

  return (
    <Drawer anchor="right" open={isOpen} onClose={handleClose} sx={defaultDrawerSX}>
      <DrawerContainer isOpen={isOpen} hasData={!!data} loading={loading} handleClose={handleClose}>
        {!loading && data && <TipDrawerViewContent data={data} handleClose={handleClose} />}
      </DrawerContainer>
    </Drawer>
  )
}
